import { createContext } from 'react';

import type { PdfPhotometryType, PhotometrySelection } from '../utils/pdfPlotGeneration/photometryMapping';

interface ExportState {
  checkedItems: Record<string, boolean>;
  handleCheck: (id: string) => void;
  /** Photometries (plots and table rows) to include in the PDF. */
  selectedPhotometries: PhotometrySelection;
  handlePhotometryCheck: (photometry: PdfPhotometryType) => void;
  selectedMeasurements: Record<string, boolean>;
  handleMeasurementCheck: (id: string) => void;
  numPages: number | null;
  setNumPages: (num: number | null) => void;
}

export const ExportContext = createContext<ExportState | undefined>(undefined);
